module.exports = {
          srcSet: "/assets/images/d29e4ed6af4084a7d76247ebe28e4630-400.png"+" 400w"+","+"/assets/images/647ecea0b35c3cd07a9c0a6dd12d9c04-530.png"+" 530w",
          images:[ {path: "/assets/images/d29e4ed6af4084a7d76247ebe28e4630-400.png",width: 400,height: 419},{path: "/assets/images/647ecea0b35c3cd07a9c0a6dd12d9c04-530.png",width: 530,height: 555}],
          src: "/assets/images/d29e4ed6af4084a7d76247ebe28e4630-400.png",
          toString:function(){return "/assets/images/d29e4ed6af4084a7d76247ebe28e4630-400.png"},
          placeholder: undefined,
          width: 400,
          height: 419
      }